import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import lineItemKeys from '@/api/queries/lineItems/keyFactory';
import { graphql } from '@/gql';
import { GetLineItemQuery } from '@/gql/graphql';

const GET_LINE_ITEM = graphql(`
  query GetLineItem($lineItemId: ID!) {
    lineItem(id: $lineItemId) {
      id
      name
      description
      thumbnailUrl
      price {
        taxRate {
          id
          label
          percentage
        }
        unitPrice {
          currency {
            code
            exponent
            id
          }
          value
        }
        unitPriceExcTax {
          currency {
            code
            exponent
            id
          }
          value
        }
        markupPercentage
        markupAmount {
          currency {
            code
            exponent
            id
          }
          value
        }
        cisDeductionRate
      }
      accountingIntegrationSyncData {
        xero {
          accountIdentifier
        }
        quickbooks {
          accountIdentifier
        }
      }
      materials {
        id
        materialQuantity
        material {
          id
          name
          image {
            id
            thumbnailUrl
          }
          tags {
            id
            name
            colour
          }
          suppliedBy {
            supplier {
              id
              name
            }
            price {
              unitPriceExcTax {
                value
                currency {
                  code
                  exponent
                  id
                }
              }
              unitPrice {
                value
                currency {
                  code
                  exponent
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`);

export type LineItemQueryData = GetLineItemQuery['lineItem'];

const useGetLineItem = (
  opts: {
    lineItemId?: string;
    enabled?: boolean;
  } = {},
  queryOptions?: Omit<UseQueryOptions<GetLineItemQuery>, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    ...queryOptions,
    enabled: opts.enabled || opts.lineItemId !== undefined,
    queryKey: lineItemKeys.lineItem(opts.lineItemId!),
    queryFn: () => {
      return gqlClient.request(GET_LINE_ITEM, {
        lineItemId: opts.lineItemId!,
      });
    },
  });
};

export default useGetLineItem;
